import { render, staticRenderFns } from "./SearchBanner.vue?vue&type=template&id=551a3e08&scoped=true"
import script from "./SearchBanner.vue?vue&type=script&lang=ts"
export * from "./SearchBanner.vue?vue&type=script&lang=ts"
import style0 from "./SearchBanner.vue?vue&type=style&index=0&id=551a3e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a3e08",
  null
  
)

export default component.exports